/**
 * Created by claudio iozzia on 06/07/2017.
 */
import {Acceptor_Common} from "../../../../models/acceptor/acceptor_common";
import {AcceptorOutputFn} from "../../../../models/acceptor/IAcceptor";
import {Ic} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {ISingleOutput} from "../../../../models/ISpec";
import {Utils} from "../../../../common/utils";
import {Flyback} from "../../../POWER/acdc/flyback";


export class Acceptor_AcLed_FlyBack extends Acceptor_Common {

  private acceptSingle_AcLed_Flyback_Vout: AcceptorOutputFn = (ic: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    const _pOut = spec.spec.value.output.globalOutput; // Global output
    const ret = Utils.isValueEmpty(out.voltage) || Utils.isValueEmpty(_pOut.voltage)
      || (ic.vout_min <= _pOut.voltage && _pOut.voltage <= ic.vout_max);
    // console.log("FlayBack Vout:", ret, ic)
    return ret;
  }

  private acceptSingle_AcLed_Flyback_Pout: AcceptorOutputFn = (ic: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    const _vin = spec.spec.value.input;
    const _pOut = spec.spec.value.output.globalOutput; // Global output
    const ret = Utils.isValueEmpty(_vin.min)
      || Utils.isValueEmpty(out.voltage) || Utils.isValueEmpty(out.current) || Utils.isValueEmpty(_pOut.power)
      || _pOut.power <= Flyback.maxLimPower(ic, _vin.min * Math.SQRT2) * (5 / 6)
    ;
    // console.log("FlayBack Pout:", ret, ic, _pOut);
    return ret;
  }

  protected singleOutputV(): AcceptorOutputFn {
    return this.acceptSingle_AcLed_Flyback_Vout;
  }

  protected singleOutputP(): AcceptorOutputFn {
    return this.acceptSingle_AcLed_Flyback_Pout;
  }

}
